module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tab-panel padded text-center"
  }, [_c('chart', {
    attrs: {
      "includeTotals": true,
      "path": "/api/people/GetChartSales"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-98c51dcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98c51dcc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/resources/ResourceOverview.vue
// module id = 2092
// module chunks = 0